import HoverTooltip from '@deltek/specification-client/core/Feedbacks/HoverTooltip'
import Checkbox from '@material-ui/core/Checkbox'
import React from 'react'
import { ColumnInstance, MetaBase, Row } from 'react-table'

/**
 * Plugin to add a checkbox column at the beginning of the table.
 * This will always be sticky.
 */
const checkboxColumn = <TData extends Object>({
    defaultCheckboxColumnWidth,
    hideCheckbox,
    getDisabled,
    disabledTooltip = '',
}: {
    defaultCheckboxColumnWidth: number
    hideCheckbox?: boolean
    getDisabled?: (row: Row<TData>) => boolean
    disabledTooltip?: string
}) => (columns: ColumnInstance<TData>[], _meta: MetaBase<TData>) => {
    return [
        {
            Header: ({ getToggleAllRowsSelectedProps }) => (
                <div>
                    <Checkbox
                        {...getToggleAllRowsSelectedProps({
                            style: { padding: 'unset', color: '#ffffff' },
                        })}
                        inputProps={{
                            'aria-label': 'Toggle All Rows Selected',
                        }}
                        className="checkbox-column-header"
                        color="primary"
                        size="small"
                    />
                </div>
            ),
            id: 'checkboxCol',
            groupByBoundary: true,
            disableResizing: true,
            disableSortBy: true,
            disableFilters: true,
            sticky: 'left',
            stickyLeftMargin: 0,
            actionColumn: true,
            maxWidth: defaultCheckboxColumnWidth,
            // The cell can use the individual row's getToggleRowSelectedProps method
            // to the render a checkbox
            Cell: ({ row }) => {
                let disabled = false
                if (getDisabled) {
                    disabled = getDisabled(row)
                }
                return hideCheckbox ? (
                    <></>
                ) : (
                    <HoverTooltip
                        text={
                            disabled ? disabledTooltip : 'Toggle Row Selected'
                        }
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-start',
                                cursor: disabled ? 'not-allowed' : 'pointer',
                            }}
                        >
                            <Checkbox
                                {...row.getToggleRowSelectedProps({
                                    style: { padding: 'unset' },
                                })}
                                checked={row.isSelected && !disabled}
                                title=""
                                disabled={disabled}
                                className="checkbox-column-cell"
                                color="primary"
                                size="small"
                                id={`checkbox-${row.id}`}
                                inputProps={{
                                    'aria-label': 'Toggle All Rows Selected',
                                }}
                            />
                        </div>
                    </HoverTooltip>
                )
            },
        },
        ...columns,
    ] as ColumnInstance<TData>[]
}

export default checkboxColumn
